import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  AlertDialogOneButton,
  LoadingDialog,
  PrimaryButton,
} from 'imports/DesignImports';

import {
  CheckCircleIcon,
  CancelIcon,
} from 'imports/IconsImports';

import {
  CircularProgress,
  List,
  ListItem,
} from 'material-ui';

class InnspiralView extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: true,
      stages: [],
      currentStage: {},
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user')
    }
  }

  componentDidMount(){
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div>
        <h2>Estado de la empresa: {this.state.user.company_name}</h2>
        {['PO', 'WS', 'FI'].includes(this.state.currentStage.stage.name) && <PrimaryButton label='Pasar a la siguiente etapa' onClick={this.nextStage} />}
        <p>El siguiente listado muestra el estado actual del proceso en la empresa. Has click en alguna de ellas para obtener más información.</p>
        <List>
          {this.state.stages.map((stage, i)=>{
            return(<ListItem
              key={i}
              primaryText={(i+1)+". "+stage.full_name}
              rightIcon={stage.order <= this.state.currentStage.stage.order ? <CheckCircleIcon color={"#4CAF50"} /> : <CancelIcon color={"#ba0f0f"} />}
              onClick={()=>{alert("to be implemented.")}}
            />)
          })}
        </List>
        {this.state.loadingDialog && <LoadingDialog />}
        {this.state.alertDialog &&
          <AlertDialogOneButton
            confirm={() => {this.setState({alertDialog: false}); window.location.reload()}}
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            />
        }
      </div>
    );
  }

  nextStage = () => {
    this.setState({loadingDialog: true});
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.patch(routes.nextStage(this.state.user.company_id))
    .then((response) => {
      this.setState({
        loadingDialog: false,
        alertDialog: true,
        alertTitle: '¡Muy bien!',
        alertMessage: 'La empresa a pasado a la siguiente etapa: ' + response.data.stage.full_name
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loadingDialog: false,
        alertDialog: true,
        alertTitle: '¡Error!',
        alertMessage: 'Ha surgido un error al intentar que la empresa pase de etapa, por favor contacta al soporte de la plataforma',
      });
    });
  }

  getData = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });

    var getStages = connection.get(routes.getStages)
    var getCurrentStage = connection.get(routes.getCurrentStage(this.state.user.company_id))

    Promise.all([getStages, getCurrentStage])
    .then((responses) => {
      this.setState({
        stages: responses[0].data.stages,
        currentStage: responses[1].data[responses[1].data.length - 1],
        error: false,
        loading: false,
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        error: true,
        loading: false,
      });
    });

  }
}

export default withCookies(withRouter(InnspiralView));



// WEBPACK FOOTER //
// ./src/views/administration/InnspiralView.js